import { RefObject, useLayoutEffect } from "react";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { panelStore } from "entities/Panel";
import { useDebounce } from "shared/hooks/useDebounce.hook";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";

import { usePanelViews } from "../../shared/usePanelViews.hook";

type OpenCardFunc = (card: ShipmentModel) => void;
type UseCardHandlersReturnType = {
  openCard: OpenCardFunc;
};

export const useCardHandlers = ({
  openedCardAction,
}: {
  openedCardAction: (card: ShipmentModel | null) => { type: string; payload: ShipmentModel | null };
}): UseCardHandlersReturnType => {
  const dispatch = useAppDispatch();
  const { showOpenedCardView } = usePanelViews();

  const openCard: OpenCardFunc = (card) => {
    dispatch(openedCardAction(card));
    showOpenedCardView();
  };
  return {
    openCard,
  };
};

export const useMainViewScrollRestoration = (containerRef: RefObject<HTMLDivElement | null>) => {
  const dispatch = useAppDispatch();
  const mainViewScrollPosition = useAppSelector(panelStore.selectors.mainViewScrollPosition);
  const { debounce } = useDebounce(250);

  const handleScroll = () => {
    debounce(() => {
      if (!containerRef.current) return;
      dispatch(panelStore.actions.setMainViewScrollPosition(containerRef.current.scrollTop));
    });
  };

  useLayoutEffect(() => {
    const element = containerRef.current;
    if (!element) return;
    element.addEventListener("scroll", handleScroll);
    if (mainViewScrollPosition) {
      element.scrollTo({
        top: mainViewScrollPosition,
      });
    }
    return () => {
      element.removeEventListener("scroll", handleScroll);
    };
  }, []);
};
